<template>

    <div class="grid mb-5 adicionar-carrinho-tamanhos" >
       
        <div v-for="t in displayTamanhos" :key="t.id"
            :class="(t.isSelecionado) ? 'adicionar-carrinho-tamanho selecionado mt-2' : 'adicionar-carrinho-tamanho mt-2'"
            @click="t.isSelecionado = !t.isSelecionado,this.$emit('update:value', displayTamanhos.filter(c => c.isSelecionado))">
            <span class="p-2">
                {{ t.nomeTamanho }}
                <!-- <span v-if="mostrarEstoque">({{ t.qnt }})</span> -->
            </span>
        </div>
        <!-- <button v-if="displayTamanhos.length < tamanhos.length" @click="displayTamanhos = tamanhos.slice(0, displayTamanhos.length + 3)" class="btn btn-link p-0 mt-2">
            Ver mais
        </button> -->
         <div class="col-12" style="text-align: right;" v-if="displayTamanhos.length < tamanhos.length">
             <label  @click="vermais" style="cursor:pointer;">
                 ver mais...
                 </label>
         </div>
        
    </div>


</template>

<script>

export default {
    name: "PrecoFiltro",
    props: {
        value: {
            type: Array,
            default: () => []
        }
    },
    emits: [
        'update:value'
    ],
    data: function () {
        return {
            tamanhos: [],
            displayTamanhos: []

        }
    },
    
     mounted() {
        if (this.value.length > 0) {
            this.tamanhos = this.$utils.getStdObject(this.value);
            //this.displayCores = this.value.slice(0, 3);
            this.displayTamanhos.push(...this.tamanhos.slice(this.displayTamanhos.length, this.displayTamanhos.length + 3));
        }
    },
    methods: {
        vermais() {
            // this.displayTamanhos = this.tamanhos.slice(0, this.displayTamanhos.length + 3);
            this.displayTamanhos.push(...this.tamanhos.slice(this.displayTamanhos.length, this.displayTamanhos.length + 3));
        }
    },
}
</script>

<style lang="scss" scoped></style>